import React, {forwardRef} from 'react';
import {FormGroup, InputGroup} from '@blueprintjs/core';

interface SubjectProps {
  value: string;
  onChange: (value: any) => void;
  disabled: boolean;
}

export const Subject = forwardRef(({
  value,
  onChange,
  disabled,
}: SubjectProps, ref: any) => {
  const onInputChange = (event: any) => {
    if(disabled) {
      return;
    }

    const value = event.target.value;
    onChange(value);
  }

  return (
    <FormGroup label="Subject">
      <InputGroup
        id="subject"
        value={value}
        className="subject-input"
        onChange={onInputChange}
        fill={true}
        disabled={disabled}
      />
    </FormGroup>
  );
});

export default Subject;
